import type { IconData } from '@stacksjs/iconify-core'

export const barChart: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M136 416h88a24.03 24.03 0 0 0 24-24V184a24.03 24.03 0 0 0-24-24h-88a24.03 24.03 0 0 0-24 24v208a24.03 24.03 0 0 0 24 24m8-224h72v192h-72ZM424 16h-88a24.03 24.03 0 0 0-24 24v352a24.03 24.03 0 0 0 24 24h88a24.03 24.03 0 0 0 24-24V40a24.03 24.03 0 0 0-24-24m-8 368h-72V48h72Z\"/><path fill=\"currentColor\" d=\"M48 16H16v480h480v-32H48z\"/>",
  "width": 512,
  "height": 512,
  "viewBox": "0 0 512 512"
}

export default barChart
